import { Uuid } from "@legacy-megarax/common";
import { customerResource } from "@legacy-megarax/crm-contracts";
import { useResourceProviderV2 } from "@legacy-megarax/react-client";
import { isNotNull } from "@legacy-megarax/utils";
import _ from "lodash";
import { useQuery } from "react-query";

import { isDocOfType } from "@megaron/docs-contracts";
import { useClientManager, useServiceClient } from "@megaron/react-clients";
import { ResourceId } from "@megaron/resource";
import { Failure, Ok } from "@megaron/result";

export const useCustomer = (uuid: Uuid | undefined | null) => {
  const customerProvider = useResourceProviderV2(customerResource);
  const getCustomer = (uuid: Uuid) =>
    customerProvider
      .byUuid(uuid)
      .retrieve()
      .flatMapError((err) => (err === "CustomerNotFound" ? Ok(null) : Failure(err)))
      .then((r) => r.assertOk().value);

  const { data: customer } = useQuery(["customer", uuid], () => getCustomer(uuid!) ?? null, {
    enabled: !!uuid,
  });

  return uuid && customer;
};

export const useCustomers = (uuids: Uuid[]) => {
  const q = useClientManager("docs")
    .retrieveDocs()
    .useQuery({
      docIds: uuids.map((i) => ResourceId("customer", i)),
    });

  const dictionary = _(q.data)
    .filter(isNotNull)
    .filter(isDocOfType("customer"))
    .keyBy(({ uuid }) => uuid)
    .value();

  return dictionary;
};
